import { render, staticRenderFns } from "./SettingsStageBestOf.vue?vue&type=template&id=2d22ceaa&"
import script from "./SettingsStageBestOf.vue?vue&type=script&lang=js&"
export * from "./SettingsStageBestOf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports